import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled } from '../../../themeConstants'

const styles = StyleSheet.create({
    noNotificationsBlock: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    noNotificationIcon: {
        width: 120,
        height: 120,
    },
    noNotificationTextBlock: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    noNotificationTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    noNotificationSubtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    noScreenContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 100,
    },
    headerNotifications: {
        flexDirection: 'column',
        paddingHorizontal: 12,
        paddingVertical: 10,
    },
    headerTitle: {
        fontSize: 21,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginBottom: 2,
    },
    headerSubtitle: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    labelsBlock: {
        flexDirection: 'row',
    },
    labels: {
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: theme.colors.colorPrimary,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginLeft: 15,
    },
    labelsText: {
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    NotificationsBlock: {
        flex: 1,
        marginTop: 10,
    },
    notificationData: {
        flexDirection: 'row',
        width: '70%',
        alignItems: 'center',
    },
    ItemsBlock: {
        flexDirection: 'row',
        paddingHorizontal: 0,
        padding: 10,
        marginBottom: 0,
        marginHorizontal: 7,
        alignItems: 'center',
    },
    ItemsBlockRead: {
        flexDirection: 'row',
        paddingHorizontal: 0,
        padding: 10,
        marginBottom: 10,
        marginHorizontal: 7,
        alignItems: 'center',
        opacity: 0.5,
    },
    ItemsBlockUnread: {
        flexDirection: 'row',
        paddingHorizontal: 0,
        padding: 10,
        marginBottom: 10,
        marginHorizontal: 7,
        alignItems: 'center',
    },
    notificationTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 5,
        color: theme.colors.textPrimary,
    },
    notificationSubtitle: {
        fontSize: 13,
        fontWeight: 'normal',
        marginBottom: 5,
        color: theme.colors.textPrimary,
    },
    notificationDate: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginTop: 4,
    },
    notificationIcon: {
        width: 40,
        height: 40,
        marginLeft: 5,
        marginRight: 10,
        borderRadius: 5,
    },
    textBlockItem: {
        flex: 1,
        flexDirection: 'column',
    },
    notificationStatusRead: {
        width: 90,
        borderRadius: 5,
        borderWidth: 0,
        backgroundColor: theme.colors.inputBackground,
        borderColor: theme.colors.colorPrimary,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginHorizontal: 10,
    },
    notificationStatusUnread: {
        width: 90,
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: theme.colors.colorPrimary,
        backgroundColor: theme.colors.colorPrimary,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginHorizontal: 10,
    },
    notificationStatusTextRead: {
        fontSize: 13,
        fontWeight: '600',
        textAlign: 'center',
        color: theme.colors.textPrimary,
    },
    notificationStatusTextUnread: {
        fontSize: 13,
        fontWeight: '600',
        textAlign: 'center',
        color: 'white',
    },
    floatingButtonText: {
        color: theme.colors.colorPrimary,
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'left',
        marginHorizontal: 12,
        marginBottom: 15,
    },
    horizontalLine: {
        borderBottomWidth: 2.0,
        borderBottomColor: theme.colors.colorPrimary,
        width: 142,
        marginHorizontal: 12,
        marginTop: 1,
        marginBottom: 15,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    containerTags: {
        height: 30,
        flexDirection: 'row',
    },
    tags: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
})

export default styles
